<div class="label-level-with-stars">
  <span>{{ displayStars() }}</span>
  <span>{{ levelLabelName }}</span>
</div>
